// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.semantic-view {
  min-height: 100vh;
  min-height: 100svh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.semantic-header {
  position: sticky;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  height: auto;
  min-height: var(--header-height);
  width: 100%;
  background-color: #f1f3f5;
  box-shadow: var(--cellula--elevation--skim);
  /* Needs to use a high z-index to have it appear on top of other elements */
  z-index: 2;
}
.semantic-header:has(.representation-banner) {
  box-shadow: none;
}
@media screen and (max-width: 700px) {
  .semantic-header.hide-on-small-devices {
    display: none;
  }
}

.semantic-main {
  position: relative;
  width: 100%;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  margin-bottom: var(--header-height);
  overflow: hidden;
  background-color: var(--cellula--color--neutral--100);
  z-index: 1;
  min-height: calc(95vh - 48px);
}
@media screen and (max-width: 700px) {
  .semantic-main.full-screen {
    top: 0;
    margin: 0;
    min-height: 100%;
  }
}

.semantic-footer {
  width: 100%;
  overflow: hidden;
  min-height: 332px;
  background-color: var(--cellula--color--primary--300);
}
@media screen and (max-width: 700px) {
  .semantic-footer.hide-on-small-devices {
    display: none;
  }
}
.semantic-footer.hide {
  display: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
